import Vue from 'vue';

Vue.prototype.$style = {
  inputBox: {
    mandatory: '#F3E5F5',
  },
  listTotal: {
    filter: '#fffdf8',
    result: '#fff6df'
  },
  purchase: {
    titlebar: '#fff6df',
  },
}
